(ns ballot-scout-v2-frontend.components.link
  (:require [reitit.frontend.easy :as rtfe]))

(defn href
  "Return relative url for given route. Url can be used in HTML links."
  ([k]
   (href k nil nil))
  ([k params]
   (href k params nil))
  ([k params query]
   (rtfe/href k params query)))

(defn link
  "Takes either a route keyword or a map describing a route with the following keys
   - route-name
   - params
   - query

   and children components.

   Returns an 'A' element that wraps the children components and links to the given route"
  [{:keys [route-name params query class] :as props} & children]
  (let [url (if (map? props)
              (href route-name params query)
              (href props))]
    [:a {:href url :class class}
     (into [:<> children])]))
